"use client";

import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import CreditOrderDetailContent from "./creditOrderDetailContent";

export default function CreditOrderDetailView() {
  const navigate = useNavigate();
	const location = useLocation();
	const recieptno = location.state?.recieptno || null;

  return <CreditOrderDetailContent navigate={navigate} recieptno={recieptno} />;
}
